import type { IExtractRouteParamMap, IRouteTranslation } from "../../../types";
import { createBreadcrumbObject, createPaths, rebase } from "../../../utils";

// Base route constant
const baseRoute = `/journal-papers`;

// * Route configuration object for journalPapers-related paths.
// ! This object is `readonly` to ensure route parameters are extracted properly.
export const journalPapersRoutesObj = {
  list: baseRoute,
  create: `${baseRoute}/create`,
  view: `${baseRoute}/view/:journalPaperId`,
  edit: `${baseRoute}/edit/:journalPaperId`,
} as const;

// ! these are breadcrumbs translation not page title
const journalPaperRouteTranslation: IRouteTranslation<
  typeof journalPapersRoutesObj
> = {
  list: "journalPapersList",
  create: "addPaper",
  edit: "editPaper",
  view: "viewPaper",
};

// * Extracts the route parameters for the journalPapers route configuration.
export type IJournalPapersRouteParams = IExtractRouteParamMap<
  typeof journalPapersRoutesObj
>;

// * Path functions for the journalPapers routes.
export const journalPapersPath = createPaths<
  typeof journalPapersRoutesObj,
  IJournalPapersRouteParams
>(journalPapersRoutesObj);

// * Breadcrumbs {translation and route} for the faculty routes
export const journalPaperBreadcrumbs = createBreadcrumbObject<
  typeof journalPapersRoutesObj
>(journalPapersRoutesObj, journalPaperRouteTranslation);
rebase(journalPaperBreadcrumbs, "list");
